<div class="drawer-content">
    <mat-nav-list>
        <mat-accordion>
            <mat-list-item routerLinkActive="active" routerLink="/claims/tts" appAppDrawer>
                <mat-icon>shopping_bag</mat-icon>
                <div class="title" mat-line>Tiktok Shop</div>
            </mat-list-item>
            <mat-list-item routerLinkActive="active" routerLink="/claims/shopee" appAppDrawer>
                <mat-icon>shopping_bag</mat-icon>
                <div class="title" mat-line>Shopee</div>
            </mat-list-item>
        </mat-accordion>
    </mat-nav-list>
</div>
